exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal {\r\n  text-align: center;\r\n  padding: 0!important;\r\n}\r\n\r\n.modal:before {\r\n  content: '';\r\n  display: inline-block;\r\n  height: 100%;\r\n  vertical-align: middle;\r\n  margin-right: -4px; /* Adjusts for spacing */\r\n}\r\n\r\n.modal-dialog {\r\n  display: inline-block;\r\n  text-align: left;\r\n  vertical-align: middle;\r\n}\r\n.ng2-pagination > li {\r\n    font-size:16px !important;\r\n    cursor:pointer;\r\n}\r\n.ui-datepicker { position: relative; z-index: 10000 !important; }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/postcss-loader?{"ident":"postcss"}!C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/css/bi.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/css/bi.css
// module chunks = 2